/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetPublicTmpDocumentByFilenameHash$Params {

/**
 * the documentHash
 */
  documentHash: string;
}

export function getPublicTmpDocumentByFilenameHash(http: HttpClient, rootUrl: string, params: GetPublicTmpDocumentByFilenameHash$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, getPublicTmpDocumentByFilenameHash.PATH, 'get');
  if (params) {
    rb.path('documentHash', params.documentHash, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

getPublicTmpDocumentByFilenameHash.PATH = '/public/documents/temp/{documentHash}';
